import { usePodcastStore } from "@/store/podcastStore";


export async function reloadPodcast() {
    setTimeout(async () => {
        await usePodcastStore().fetchPodcasts();
    }, 500);
}